import { action } from 'satcheljs/lib/legacy';
export default action('updateLastFocusedControl')(function updateLastFocusedControl(viewState, composeControl) {
    viewState.lastFocusedControl = composeControl;
});
//# sourceMappingURL=updateLastFocusedControl.js.map